import { useEffect, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import { useSearchParams } from "react-router-dom";
import Loader from '../../components/Loader';

const UserPurchaseResult = () => {

    // Catturo l'id della request in query e faccio partire la fetch per aggiornarla e mandare le email di conferma e scambio contatti

    const [searchParams] = useSearchParams();
    const session_id = searchParams.get('session_id');
    const requestId = searchParams.get('requestId');
    useEffect(() => {
        console.log('requestId: ', requestId);
        if (session_id, requestId) {
            sendFinalPurchaseFetch();
        }
    }, [session_id, requestId])

    const [fetchStatus, setFetchStatus] = useState('loading');
    const [error, setError] = useState(false);
    const sendFinalPurchaseFetch = async () => {
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/requests/final-purchase-step/${requestId}`;
        const headers = { 'Content-Type': 'application/json' };
        const options = { method: 'PATCH', headers, body: JSON.stringify({ sessionId: session_id }) };
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                setFetchStatus('succeeded');
            } else {
                const error = await response.json();
                throw error
            }
        } catch (error) {
            console.error('error: ', error);
            setError(error.message || `Errore nel gestire la richiesta.`);
            setFetchStatus('failed');
        }
    }

    useEffect(() => {
        if (fetchStatus === 'succeeded') {
            setTimeout(() => {
                window.location.href = "/"
            }, 5000)
        }
    }, [fetchStatus])

    return (
        <PageContainer items="center">
            {
                session_id &&
                <h2>Pagamento avvenuto con successo.</h2>
            }
            {
                fetchStatus === 'loading' &&
                <div className='mt-8'>
                    <Loader />
                </div>
            }
            {
                fetchStatus === 'failed' &&
                <div className='mt-8'>
                    <div>{error}</div>
                    <div>Per chiarimenti contattare lo staff di Ticino Wild all'indirizzo info@ticinowild.ch fornendo l'id della richiesta: {requestId}</div>
                </div>
            }
            {
                fetchStatus === 'succeeded' &&
                <div className='mt-8'>
                    <h3 className='text-green-500'>Complimenti! L'acquisto della tua nuova esperienza è andato a buon fine!</h3>
                    <p>Sia a te che all'azienda è stata inviata un'email di recap con i rispettivi dati. Verrai ricontattat* per definire gli ultimi dettagli e fissare la data dell'esperienza.</p>
                    <p>Lo staff di <b>TicinoWild</b></p>
                </div>
            }
        </PageContainer>
    )
}

export default UserPurchaseResult;